import { render, staticRenderFns } from "./XConnectionWarning.vue?vue&type=template&id=007885f1&"
import script from "./XConnectionWarning.vue?vue&type=script&lang=js&"
export * from "./XConnectionWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports